import { render, staticRenderFns } from "./setLevel.vue?vue&type=template&id=65643c68"
import script from "./setLevel.vue?vue&type=script&lang=js"
export * from "./setLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports